<template>
<div>
<mu-table :showCheckbox="false" 
    @rowClick="trRoute" style="border: 1px solid #e1e8e9;">
    <mu-thead>
        <mu-tr>
            <mu-th class="pointer">Recep</mu-th>
            <mu-th>Colis</mu-th>
            <mu-th class="medium-hide">Manque</mu-th>
            <mu-th>Valider</mu-th>
        </mu-tr>
    </mu-thead>
    <mu-tbody>
        <mu-tr v-for="(item, index) in vouchTb" 
            :key="index" @click="trRoute(index)" v-bind:class="{ 'bg-light-green100': !item[1], pointer:true }">
            <mu-td>{{item[0].desti}}</mu-td>
            <mu-td>{{item[0].barcode_scan}} / <b>{{item[0].barcode_count}}</b></mu-td>
            <mu-td class="medium-hide">{{item[1]}}</mu-td>
            <mu-td>
                <mu-flat-button v-if="item[1]" icon="done_all" @click.stop="scanAll(item[0].recref)" />&nbsp;
                <mu-flat-button icon="print" @click.stop="printRecep(item[0].rowid)" />
            </mu-td>
        </mu-tr>
    </mu-tbody>
</mu-table>
</div>
</template>

<script>
import icon       from 'muse-components/icon'
import iconButton from 'muse-components/iconButton'
import {table, thead, tbody, tfoot, tr, td, th }    from 'muse-components/table'
import {col, row} from 'muse-components/grid'
import flatButton from 'muse-components/flatButton'

export default {
    name: 'scan-vouch',
    props: ['cbtable', 'scanMode', 'modeData', 'scanControl'],
    data: function () {
        return {
            pref: this.$auth.userPref,
            vouch: this.modeData.fk_soc
        }
    },
    computed: {
        vouchTb : function() {
            var sortable = []
            var scan, bScan, bCount = 0
            for (var vouch in this.cbtable[this.modeData.fk_soc]['vouch']) {
                bCount = parseInt(this.cbtable[this.modeData.fk_soc]['vouch'][vouch]['barcode_count'])
                bScan  = parseInt(this.cbtable[this.modeData.fk_soc]['vouch'][vouch]['barcode_scan'])
                scan   = bCount - bScan
                sortable.push([ this.cbtable[this.modeData.fk_soc]['vouch'][vouch], scan ]);
            }
            sortable.sort(function(a, b) {
                return b[1] - a[1]
            })
            return sortable
        }
    },
    mounted: function() {},
    methods: {
        trRoute (index) {
            this.scanMode('barcode', this.vouchTb[index][0]['recref'])
        },
        scanAll (recref) {
            let barcode
            let codeTb = []
            for( barcode in this.cbtable[this.modeData.fk_soc]['vouch'][recref]['barcode'] ){
                codeTb.push( barcode )
            }
            this.scanControl( codeTb )
        },
        // Impression PDF
        printRecep(id) {
            let vouchKey = [ id ]
            window.axios.get( '/', {
                params: { _method:'GET', _path:'report/recep', recep: vouchKey },
                responseType:"blob"
            })
            .then( (response) => {
                this.$download(response.data, "recep.pdf", "application/pdf")
            })
        }
    },
    components: {
        'mu-icon': icon,
        'mu-icon-button': iconButton,
        'mu-table': table, 'mu-thead': thead, 'mu-tbody': tbody, 'mu-tfoot': tfoot,
        'mu-tr': tr, 'mu-td': td, 'mu-th': th,
        'mu-flat-button': flatButton
    }
}
</script>

<style lang="less">
@media only screen and (max-width : 768px) {
    .medium-hide {
        display: none;
    }
}
</style>


// WEBPACK FOOTER //
// Scan_vouch.vue?3753cd03